import React, { useEffect } from 'react';
import { AssignmentStatus, EldMovement } from 'src/common/types';
import './movements.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getDriverInfo } from 'src/features/profile/store';
import { convertISOTimeToHours } from 'src/helpers/driverEldInfoHelper';

import { Button } from '../../../components/Button/Button';
import { acceptMovements, claimMovements, setMovementClaimed } from '../store/movementStore';

interface ClaimMovementProps {
  movement: EldMovement;
  type: AssignmentStatus;
}

export const ClaimMovement: React.FC<ClaimMovementProps> = ({ movement, type }) => {
  const driverInfo = useSelector(getDriverInfo);
  const positiveTitle = type === AssignmentStatus.PROPOSED ? 'Accept' : 'Claim';
  const dispatch = useDispatch();

  // scroll to the top of the page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleClaim = (movementId: number) => {
    if (type === AssignmentStatus.PROPOSED) {
      dispatch(acceptMovements({ employeeId: driverInfo.employeeId, editIds: [movementId] }));
    } else {
      dispatch(claimMovements({ employeeId: driverInfo.employeeId, movements: [movementId] }));
    }
    dispatch(setMovementClaimed({ type, movementId }));
  };

  // eslint-disable-next-line new-cap
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className="claim-movement-box">
      <div className="claim-movement-text">
        {type === AssignmentStatus.PROPOSED ? (
          <>
            <div>
              {convertISOTimeToHours(movement.startTimestamp, timezone)} -{' '}
              {convertISOTimeToHours(movement.endTimestamp, timezone)}
            </div>
          </>
        ) : (
          <>
            <div>
              {convertISOTimeToHours(movement.startTimestamp, timezone)} -{' '}
              {convertISOTimeToHours(movement.endTimestamp, timezone)}
            </div>
            <div>
              {movement.startLocationString} to {movement.endLocationString}
            </div>
            <div>{Number(movement.elapsedOdometer?.toFixed(2))} mi</div>
          </>
        )}
      </div>
      <div className="claim-movement-buttons">
        {movement.claimed ? (
          <Button title="✔️" style={{ color: 'blue' }} />
        ) : movement.rejected ? (
          <Button title="❌" style={{ color: 'red' }} />
        ) : (
          <>
            <Button
              title={positiveTitle}
              className="claim-movement-button"
              onClick={() => handleClaim(movement.movementId)}
            />
          </>
        )}
      </div>
    </div>
  );
};
